(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["password"]) return;
  try {
    
  function initPasswordCountdowns() {
    document.querySelectorAll('[data-password-countdown]').forEach((countdown) => {
      if (countdown.dataset.initialized === 'true') return;
      countdown.dataset.initialized = 'true';

      const end = Date.parse(countdown.dataset.end);
      if (Number.isNaN(end)) return;

      const daysEl = countdown.querySelector('[data-days]');
      const hoursEl = countdown.querySelector('[data-hours]');
      const minutesEl = countdown.querySelector('[data-minutes]');
      const secondsEl = countdown.querySelector('[data-seconds]');
      const expiredEl = countdown.querySelector('[data-expired]');
      const units = countdown.querySelectorAll('.password-countdown__unit');

      function pad(value) {
        return String(value).padStart(2, '0');
      }

      function tick() {
        const diff = end - Date.now();

        if (diff <= 0) {
          units.forEach((unit) => unit.classList.add('is-hidden'));
          expiredEl?.classList.remove('is-hidden');
          return;
        }

        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        daysEl.textContent = pad(days);
        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  document.addEventListener('DOMContentLoaded', initPasswordCountdowns);
  document.addEventListener('shopify:section:load', initPasswordCountdowns);

  } catch(e) { console.error(e); }
})();
})();
